import React from 'react'
import {inject, observer} from "mobx-react";
import {Dropdown, Button, Form, Modal} from "react-bootstrap";
import {FormField} from "./field";
import {PersonForm} from './person.form';
import {PaymentForm} from "./payment.form";


const DateAlert = () => {
    return (
        <div className={"row"}>
            <br/><br/>
            <div className={"alert alert-warning"}>Dear customers, the return flight you have chosen is close. Please fill in the details below and we will get back to you by email immediately after receiving a response from the lab regarding availability and price.</div>
        </div>

    )
}

@inject ("formStore","validationModal") @observer
class FullForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            validated : false
        }
    }
    render() {
        const s = this.props.formStore;

        const handleSubmit = (event) => {
            const form = event.currentTarget;
            if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
            }

            this.setState({
                validated : true
            });

            s.validateForm();

            event.preventDefault();
            event.stopPropagation();
            //setValidated(true);


            if (!s.isFormValid) {
                this.props.validationModal.openModal();
                return;
            }

            s.postForm();
        };

        if (s.isSubmitted) {
            return (
                <div className="alert alert-success" role="alert">
                    The form has been sent successfully, we will get back to you soon.
                </div>

            )
        }

        const dateAlert  = (s.showDateAlert) ? <DateAlert/> : "";
        const btnText = (s.showDateAlert) ? "Send form" : "Continue to pay";

        return (
            <div>
                <Form noValidate onSubmit={handleSubmit}>
        <div className={"row"}>
            <div className={"col-md-12"}>
                <h1>Book Your Covid-19 Test in Your Hotel!</h1>
                <p>Dear passengers,<br/>
                    Please fill out the below form in order for us to book your Covid-19 test at your hotel.
                </p>

                <p>After filling out the form you will be transferred to a payment page. </p>
                <p>Before we begin, few important details for your information:</p>
                <ul>
                    <li>According to the Health Ministry restrictions, each person who stayed abroad for more than 72 hours (3 days) must provide a negative Covid-19 test result before boarding.</li>
                    <li>Providing negative Covid-19 test result is mandatory for all passengers on the flight - either vaccinated, recovered, children and infants , (all subject to the guidelines of the Ministry of Health).</li>
                    <li>Airlines are not allowed to accept to the flight passengers without a negative PCR Covid-19 test results typed in English. </li>
                    <li>When you book a Covid-19 test from us, we take full responsibility to provide you with the test results on time. </li>
                    <li>Laboratory representatives arrive to all central hotels. If you are not staying in one of the central hotels, you will be able to have the test in a short drive away from the hotel in one of the Laboratory's stations. </li>
                    <li>A receipt will be sent to you immediately after booking and paying through this site. </li>
                    <li>If the test will be performed at the hotel you are staying, you will receive an email 48 hours before the test date with the exact time of the test. If you need to get to one of the laboratory's test stations, we will contact you shortly after placing the reservation on WhatsApp or by email, and you will also receive an email after around 48 hours regarding the test exact time.</li>
                    <li>Test results will be sent to you by email within one day before your return flight. </li>

                </ul>
            </div>

                <div className={"col-md-12"}>
                    <p><strong>Please select your destination:</strong></p>
                </div>

            {s.prices.map((priceObj, index) => {
                const dest = (priceObj.title) ? priceObj.title : (priceObj.destination + " Covid-19 test €" + priceObj.price + " per person.");

                return (
                    <div key={"dest-"+index} className={"form-group col-md-12"}>
                        <Form.Check name={"destination_field"}
                                    id={"destination_"+index}
                                    type={"radio"}
                                    label={dest}
                                    checked={s.destination === dest}
                                    onChange={() => {
                                        s.setDestination(dest);
                                        s.setDestinationObj(priceObj);
                                    }}/>
                    </div>
                )
            })}

            <div className={"col-md-12"}>
                <div>
                    <div className="row">
                        <div className="form-group col-md-6">
                            <FormField field={s.customerName} maxLength={30}/>
                        </div>

                        <div className="form-group col-md-6">
                            <FormField field={s.email} maxLength={50} onBlur={() => {s.fillPaymentData();}}/>
                        </div>
                    </div>

                    <div className={"row"}>
                        <div className="form-group col-md-6">
                            <FormField field={s.mobilePhone} maxLength={15} onBlur={() => {s.fillPaymentData();}}/>
                        </div>

                        <div className="form-group col-md-6">
                            <label className={"ui-label"}>Passenger’s quantity:</label>
                            <Dropdown>
                                <Dropdown.Toggle variant="light" id="dropdown-basic">
                                    {s.passengerCount}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {s.passengersArr.map((item) => {
                                        return <Dropdown.Item key={"passenger" + item} onClick={() => {
                                            s.passengerCount = item;
                                            s.updateArray();
                                        }}>{item}</Dropdown.Item>
                                    })}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>


                    <div className={"row"}>
                        <div className={"col-md-6"}>
                            <FormField field={s.hotel} maxLength={25}/>
                        </div>

                        <div className={"col-md-6"}>
                            <FormField field={s.returnDate} maxLength={15}/>
                        </div>
                    </div>


                </div>


            </div>
        </div>
                {dateAlert}
            <div className={"row"}>
                <div className={"col-md-12"}>
                    <br/><br/>
                </div>
                {s.passengers.map((item,index)=>{
                    return <PersonForm key={"person"+index} person={item} number={index+1} />
                })}
            </div>

            <div className={"row"}>
                <div className={"col-md-12"}>
                    <PaymentForm/>
                </div>
            </div>

                <div className={"row"}>

                    <div className={"col-md-10"}>
                        <br/><br/>
                    <p>BlueBird Airways acts solely as an intermediary and takes no liability for the use and security of the information once it is received by the laboratory to which the information is to be transferred. Filling in and sending the details signifies consent to transfer the information about all the passengers in the booking (including minors).</p>
                    </div>

                    <div className={"col-md-2"}>
                        <br/><br/>
                        <Button type={"submit"} variant="primary">{btnText} </Button>

                    </div>
                </div>

                <div className={"row"}>
                    <div className={"col-md-12"}><br/></div>
                </div>
                </Form>
        </div>);

    }
}

export {FullForm}